export type boardgame = "boardgame";
export type boardgameaccessory = "boardgameaccessory";
export type boardgamecompany = "boardgamecompany";
export type boardgamecompilation = "boardgamecompilation";
export type boardgameexpansion = "boardgameexpansion";
export type boardgamefamily = "boardgamefamily";
export type boardgameimplementation = "boardgameimplementation";
export type boardgameintegration = "boardgameintegration";
export type boardgameperson = "boardgameperson";
export type family = "family";
export type rpg = "rpg";
export type rpgcompany = "rpgcompany";
export type rpgissue = "rpgissue";
export type rpgitem = "rpgitem";
export type rpgperiodical = "rpgperiodical";
export type rpgperson = "rpgperson";
export type thing = "thing";
export type videogame = "videogame";
export type videogamecompany = "videogamecompany";

/** YYYY-MM-DD */
export type Date = string;

/** YYYY-MM-DD HH:MM:SS */
export type DateTime = string;
